import type { FC } from "react";

const ConnectWalletNote: FC = () => (
  <div className="flex flex-col gap-3 rounded-lg border border-border p-4">
    <h3>Your assets</h3>
    <span className="text-sm text-muted-foreground">
      Connect your wallet to use faucet
    </span>
  </div>
);

export default ConnectWalletNote;
